module.exports = __webpack_public_path__ + "static/consulting-partner-6cf2c803a815574e554a7aa1737645d9.png";